import React from 'react';
import {KeyboardAvoidingView, Platform, ViewStyle} from 'react-native';

interface Props {
  children: React.ReactNode;
  style?: ViewStyle;
}

export function KeyboardAware({children, style}: Props) {
  // Android: adjustResize in manifest handles keyboard avoidance
  // Web: browser handles keyboard natively
  if (Platform.OS !== 'ios') {
    return <>{children}</>;
  }

  return (
    <KeyboardAvoidingView behavior="padding" style={[{flex: 1}, style]}>
      {children}
    </KeyboardAvoidingView>
  );
}
